import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "offer-placeholders" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loading offer-placeholder__title" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"loading offer-placeholder__address\"></div><div class=\"loading offer-placeholder__price\"></div><div class=\"loading offer-placeholder__amenity\"></div><div class=\"loading offer-placeholder__amenity\"></div><div class=\"loading offer-placeholder__amenity\"></div>", 5)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amount, (placeholder, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `placeholder-${index}`,
        class: "offer-placeholder"
      }, [
        _hoisted_2,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star, starIndex) => {
          return _createVNode(_component_icon, {
            key: `star-${starIndex}`,
            icon: ['fas', 'star']
          })
        }), 64)),
        _hoisted_3
      ]))
    }), 128))
  ]))
}